import { render, staticRenderFns } from "./fe-login-register.vue?vue&type=template&id=8f4cdec6&scoped=true"
import script from "./fe-login-register.vue?vue&type=script&lang=js"
export * from "./fe-login-register.vue?vue&type=script&lang=js"
import style0 from "./fe-login-register.vue?vue&type=style&index=0&id=8f4cdec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4cdec6",
  null
  
)

export default component.exports